module.exports = __webpack_public_path__ + "assets/blob-3-selected.e9c419bb.svg";